__webpack_require__.p = "https://dev.nudrah.com.sa/";